export default __webpack_public_path__ + "static/media/banner-img.23d5fdae.png";